import { ColumnVO, IServerSideGetRowsRequest } from '@ag-grid-community/core';
import { Hierarchy } from 'common/visualizations/vif';
import { isPivotInHierarchy } from './PivotHelpers';

export function constructAgRequestFromHierarchy(hierarchy: Hierarchy): IServerSideGetRowsRequest {
  const configs = hierarchy.columnConfigurations;
  const pivotMode = isPivotInHierarchy(hierarchy);

  const values = configs.filter((config) => !config?.isGrouping && !config.isPivoting && config.aggregation);
  const valueCols: ColumnVO[] = values.map((col) => {
    return { aggFunc: col.aggregation ?? undefined, id: col.columnName, displayName: col.columnName };
  });

  const groups = configs.filter((config) => config?.isGrouping && !config?.isPivoting);
  const rowGroupCols: ColumnVO[] = groups.map((col) => {
    return { id: col.columnName, displayName: col.columnName };
  });

  let pivotCols: ColumnVO[] = [];
  if (pivotMode) {
    const pivots = configs.filter((config) => config?.isPivoting && !config.isGrouping);
    pivotCols = pivots.map((col) => {
      return { id: col.columnName, displayName: col.columnName };
    });
  }

  const fakeAgRequest: Pick<
    IServerSideGetRowsRequest,
    'valueCols' | 'pivotCols' | 'rowGroupCols' | 'pivotMode' | 'groupKeys'
  > = {
    valueCols,
    rowGroupCols,
    pivotCols,
    pivotMode,
    groupKeys: [],
  };
  return fakeAgRequest as IServerSideGetRowsRequest;
}
